<template>
  <BaseEditorSection
    :config="lessonMaterialsConfig"
    :is-edit-form="isEditForm"
    @tabs-updated="(...args) => $emit('tabs-updated', ...args)"
    ref="baseEditor"
  />
</template>

<script setup>
/* eslint-disable no-unused-vars */
import BaseEditorSection from "../shared/BaseEditorSection.vue";
import { ref, defineEmits, defineExpose, defineProps } from "vue";
import { CATEGORY_TYPES } from "@/utils/constants";

const props = defineProps({
  isEditForm: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["tabs-updated"]);

const baseEditor = ref(null);

const lessonMaterialsConfig = {
  enableAssessment: true,
  enableAttachments: true,
  enableSlides: true,
  enableMaterials: true,
  moduleTabLabel: "Section",
  initialPlaceholder: "Start writing your lesson materials content here...",
  defaultTabStructure: "makercart-activities",
  moduleType: CATEGORY_TYPES.LessonMaterials,
  customDefaultTabs: [
    {
      name: "Overview",
      type: "module",
      sections: [
        {
          editor: null,
          content: `<p>Start writing your overview here...</p>`,
        },
      ],
    },
    {
      name: "Hook",
      type: "module",
      sections: [
        {
          editor: null,
          content: `<p>Start writing your hook here...</p>`,
        },
      ],
    },
    {
      name: "Maker Element",
      type: "module",
      sections: [
        {
          editor: null,
          content: `<p>Start writing your maker element here...</p>`,
        },
      ],
    },
    {
      name: "Reflecting & Sharing",
      type: "module",
      sections: [
        {
          editor: null,
          content: `<p>Start writing your reflecting & sharing here...</p>`,
        },
      ],
    },
    {
      name: "Exit Ticket",
      type: "module",
      sections: [
        {
          editor: null,
          content: `<p>Start writing your exit ticket here...</p>`,
        },
      ],
    },
    {
      name: "Assessment",
      type: "assessment",
      sections: [
        {
          editor: null,
          content: `<p>Start writing your assessment here...</p>`,
        },
      ],
    },
  ],
};

// Expose all methods from the base editor
defineExpose({
  updateFromParent: (...args) => baseEditor.value?.updateFromParent(...args),
  openSlideModal: () => baseEditor.value?.openSlideModal(),
  insertContent: (...args) => baseEditor.value?.insertContent(...args),
  getSlideData: () => baseEditor.value?.getSlideData(),
  isSlideAttached: () => baseEditor.value?.isSlideAttached(),
  setSlideAttachedState: (...args) =>
    baseEditor.value?.setSlideAttachedState(...args),
  getInstructionalMaterials: () =>
    baseEditor.value?.getInstructionalMaterials(),
  setInstructionalMaterials: (...args) =>
    baseEditor.value?.setInstructionalMaterials(...args),
});
</script>
